module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-icon",
    on: {
      "click": _vm.click
    }
  }, [(!!_vm.iconName) ? _c('svg', {
    attrs: {
      "width": _vm.size,
      "height": _vm.size,
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.iconName,
      "fill": _vm.color
    }
  })]) : _vm._e(), _vm._v(" "), (!!_vm.iconSrc) ? _c('img', {
    attrs: {
      "width": _vm.size,
      "src": _vm.iconSrc,
      "height": _vm.size
    },
    on: {
      "error": _vm.errorHandler
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49f13edf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/icon/rtIcon.vue
// module id = 1494
// module chunks = 91